import {
  Box, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import style from '../TaskList/style';
import STRING_KEYS from '../../../language/keys';
import { useSystemStatistics } from '../../../hooks/query/useStatistics';
import TimedSystemStatisticsSection from './TimedSystemStatisticsSection';
import GeneralSystemStatisticsSection from './GeneralSystemStatisticsSection';

export default function Statistics(): JSX.Element {
  const { t: translate } = useTranslation();
  const last7DaysResponse = useSystemStatistics(7);
  const last30DaysResponse = useSystemStatistics(30);

  return (
    <Box>
      <Typography style={ { marginBottom: 10 } } variant={ style.title.variant }>
        { translate(STRING_KEYS.HOME_PAGE.STATISTICS.TITLE) }
      </Typography>
      <Box>
        <GeneralSystemStatisticsSection
          isLoading={ last7DaysResponse.isLoading || last30DaysResponse.isLoading }
          usersData={ last7DaysResponse.data?.usersStatistics || last30DaysResponse.data?.usersStatistics }
          matchFlowsData={ last7DaysResponse.data?.matchFlowsSystemStatistics || last30DaysResponse.data?.matchFlowsSystemStatistics   }
        />
      </Box>
      <Box>
        <Box>
          <TimedSystemStatisticsSection
            daysBack={ 7 }
            isLoading={ last7DaysResponse.isLoading }
            outreachData={ last7DaysResponse.data?.outreachStatistics }
            matchesData={ last7DaysResponse.data?.matchesStatistics }
          />
        </Box>
        <Box style={ { marginTop: 30 } }>
          <TimedSystemStatisticsSection
            daysBack={ 30 }
            isLoading={ last30DaysResponse.isLoading }
            outreachData={ last30DaysResponse.data?.outreachStatistics }
            matchesData={ last30DaysResponse.data?.matchesStatistics }
          />
        </Box>
      </Box>
    </Box>
  );
}
